import apiClient from "./apiClient";

export const getWnbaModels = () => {
  return apiClient.get(`/wnba-models`);
};
